import(/* webpackMode: "eager" */ "/app/node_modules/@storyblok/react/dist/rsc/live-editing.mjs");
